import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarComponent } from './toolbar.component';
import { MaterialModuleMobi } from '../material/material.module';



@NgModule({
  declarations: [
    ToolbarComponent
  ],
  imports: [
    CommonModule,
    MaterialModuleMobi
  ],
  exports:[
    ToolbarComponent,
  ]
})
export class ToolbarModule { }
